// Credit: https://github.com/farhadi/JalaliJSCalendar
import { MINUTE_PER_MILLISECOND } from '@/components/Datepicker/constants';

type toGregorianArguments = {
  year: number | string;
  month: number | string;
  day: number | string;
};

function toGregorian({
  year: j_y,
  month: j_m,
  day: j_d,
}: toGregorianArguments): [any, any, any] {
  const jalaliDate = {
    g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
  };

  let j;
  j_y = typeof j_y === 'string' ? parseInt(j_y) : j_y;

  if (j_m > 11) {
    j_m = typeof j_m === 'string' ? parseInt(j_m) : j_m;
  } else {
    j_m = typeof j_m === 'string' ? parseInt(j_m) + 1 : j_m + 1;
  }
  j_d = typeof j_d === 'string' ? parseInt(j_d) : j_d;

  const jy = j_y - 979;
  const jm = j_m - 1;
  const jd = j_d - 1;

  let j_day_no =
    365 * jy +
    parseInt(String(jy / 33)) * 8 +
    parseInt(String(((jy % 33) + 3) / 4));
  for (let i = 0; i < jm; ++i) j_day_no += jalaliDate.j_days_in_month[i];

  j_day_no += jd;

  let g_day_no = j_day_no + 79;

  let gy =
    1600 +
    400 *
      parseInt(
        String(g_day_no / 146097)
      ); /* 146097 = 365*400 + 400/4 - 400/100 + 400/400 */
  g_day_no %= 146097;

  let leap = true;
  if (g_day_no >= 36525) {
    /* 36525 = 365*100 + 100/4 */
    g_day_no--;
    gy +=
      100 *
      parseInt(
        String(g_day_no / 36524)
      ); /* 36524 = 365*100 + 100/4 - 100/100 */
    g_day_no %= 36524;

    if (g_day_no >= 365) {
      g_day_no++;
    } else {
      leap = false;
    }
  }

  gy += 4 * parseInt(String(g_day_no / 1461)); /* 1461 = 365*4 + 4/4 */
  g_day_no %= 1461;

  if (g_day_no >= 366) {
    leap = false;

    g_day_no--;
    gy += parseInt(String(g_day_no / 365));
    g_day_no %= 365;
  }

  for (
    j = 0;
    g_day_no >= jalaliDate.g_days_in_month[j] + Number(j == 1 && leap);
    j++
  ) {
    g_day_no -= jalaliDate.g_days_in_month[j] + Number(j == 1 && leap);
  }
  let gm = j + 1;
  let gd: number | string = g_day_no + 1;

  gm = gm < 10 ? '0' + (gm - 1) : gm - 1;
  gd = gd < 10 ? '0' + gd : gd;

  return [gy, gm, gd];
}

function toJalali(g_y: number, g_m: number, g_d: number) {
  const jalaliDate = {
    g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
  };

  let j;
  g_y = parseInt(String(g_y));
  g_m = parseInt(String(g_m)) + 1;
  g_d = parseInt(String(g_d));
  const gy = g_y - 1600;
  const gm = g_m - 1;
  const gd = g_d - 1;

  let g_day_no =
    365 * gy +
    parseInt(String((gy + 3) / 4)) -
    parseInt(String((gy + 99) / 100)) +
    parseInt(String((gy + 399) / 400));

  for (let i = 0; i < gm; ++i) {
    g_day_no += jalaliDate.g_days_in_month[i];
  }
  if (gm > 1 && ((gy % 4 == 0 && gy % 100 != 0) || gy % 400 == 0)) {
    /* leap and after Feb */
    ++g_day_no;
  }
  g_day_no += gd;

  let j_day_no = g_day_no - 79;

  const j_np = parseInt(String(j_day_no / 12053));
  j_day_no %= 12053;

  let jy = 979 + 33 * j_np + 4 * parseInt(String(j_day_no / 1461));

  j_day_no %= 1461;

  if (j_day_no >= 366) {
    jy += parseInt(String((j_day_no - 1) / 365));
    j_day_no = (j_day_no - 1) % 365;
  }

  for (j = 0; j < 11 && j_day_no >= jalaliDate.j_days_in_month[j]; ++j) {
    j_day_no -= jalaliDate.j_days_in_month[j];
  }
  const jm = j + 1;
  const jd = j_day_no + 1;

  return [jy, jm - 1, jd];
}

function convertUTCDateToLocalDate(date: Date) {
  const localOffset =
    new Date(date).getTimezoneOffset() * MINUTE_PER_MILLISECOND;
  const localTime = date.getTime();
  const localDateTime = localTime - localOffset;

  return new Date(localDateTime);
}

export { toGregorian, toJalali, convertUTCDateToLocalDate };
